import { dimensions } from "./ga-custom-defs";

export const name = '$gzAnalytics';

/**
 * @ngdoc service
 * @name gazelle.core.analytics.service:$gzAnalytics
 *
 * @description
 * The $gzAnalytics service provides a consistent way to report analytic events.
 */

export default function $gzAnalytics(
  $analytics,
  $window,
  rnApplication,
  $state,
  $stateParams
) {
  'ngInject';

  const GZ_EVENT = 'GZ EVENT';

  const pathParamsRegex = /({(\w+)}|:(\w+))/g;
  const paramsRegex = /(\w+)/g;

  let service = {
    intercomTrackEvent,
    event: eventTrack,
    eventClick : eventActionClick,
    eventSave: eventActionSave,
    eventCancel: eventActionCancel,
    eventToggle: eventActionToggle,
    eventOpen: eventActionOpen,
    eventClose: eventActionClose,
    eventAdd: eventActionAdd,
    eventEdit: eventActionEdit,
    eventConfirm: eventActionConfirm,
    eventCreate: eventActionCreate,
    eventDelete: eventActionDelete,
    eventSelect: eventActionSelect,
    eventSend: eventActionSend,
    exception: exceptionTrack,
    setUserName,
    getPage,
    setAppBuContext,
  };

  return service;

  // Public functions
  function getPage() {
    if (!$state.current.analyticsParams) {
      return rnApplication.getCurrentAppId() + $state.current.url;
    }
    return rnApplication.getCurrentAppId() + getAnalyticsParamsPage();
  }

  function getAnalyticsParamsPage() {
    const analyticsParams = $state.current.analyticsParams;
    const [path, queryParams] = $state.current.url.split('?');

    let analyticsUrl = path;
    if (path) {
      analyticsUrl = path.replace(pathParamsRegex, (match, pathParam, braceParamName, colonParamName) => {
        let paramName = braceParamName || colonParamName;
        if (!analyticsParams.includes(paramName) || !$stateParams.hasOwnProperty(paramName)) {
          return pathParam;
        }
        return $stateParams[paramName];
      });
    }

    if (queryParams) {
      let newQueryParams = queryParams.replace(paramsRegex, (match, paramName) => {
        if (!analyticsParams.includes(paramName) || !$stateParams.hasOwnProperty(paramName)) {
          return paramName;
        }
        return `${paramName}=${$stateParams[paramName]}`;
      });

      analyticsUrl += `?${newQueryParams}`;
    }

    return analyticsUrl;
  }

  function eventTrack(event, eventObj = {}) {
    if (event === null || event === undefined || event.length === 0) {
      event = GZ_EVENT;
    }
    // Page set in page-analytics.run
    //eventObj.page = getPage();
    if (!eventObj.hasOwnProperty('category')) {
      eventObj.category = rnApplication.getCurrentAppId();
    }
    $analytics.eventTrack(event, eventObj);
  }

  function eventActionCancel(event, eventObj = {}) {
    eventTrack(event + ' - canceled', eventObj);
  }

  function eventActionClick(event, eventObj = {}) {
    eventTrack(event + ' - clicked', eventObj);
  }

  function eventActionToggle(event, eventObj = {}) {
    eventTrack(event + ' - toggled', eventObj);
  }

  function eventActionOpen(event, eventObj = {}) {
    eventTrack(event + ' - opened', eventObj);
  }

  function eventActionClose(event, eventObj = {}) {
    eventTrack(event + ' - closed', eventObj);
  }

  function eventActionAdd(event, eventObj = {}) {
    eventTrack(event + ' - added', eventObj);
  }

  function eventActionEdit(event, eventObj = {}) {
    eventTrack(event + ' - edited', eventObj);
  }

  function eventActionSave(event, eventObj = {}) {
    eventTrack(event + ' - saved', eventObj);
  }

  function eventActionConfirm(event, eventObj = {}) {
    eventTrack(event + ' - confirmed', eventObj);
  }

  function eventActionCreate(event, eventObj = {}) {
    eventTrack(event + ' - created', eventObj);
  }

  function eventActionDelete(event, eventObj = {}) {
    eventTrack(event + ' - deleted', eventObj);
  }

  function eventActionSelect(event, eventObj = {}) {
    eventTrack(event + ' - selected', eventObj);
  }

  function eventActionSend(event, eventObj = {}) {
    eventTrack(event + ' - sent', eventObj);
  }

  function exceptionTrack(exDescription, exFatal = false) {
    $window.ga('send', {
      hitType: 'exception',
      exDescription,
      exFatal,
    });
  }

  function setAppBuContext(appBuContext) {
    $window.ga('set', dimensions.appBuContext, appBuContext);
  }

  function setUserName(userId) {
    $analytics.setUsername(userId);
  }

  function intercomTrackEvent(event, metadata) {
    if ($window.Intercom) {
      $window.Intercom('trackEvent', event, metadata);
    } else {
      exceptionTrack('Failed to send Intercom event: ' + event);
    }
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/core/analytics/analytics.service.js